import React, { useCallback } from "react";

import { useAuth } from "@hooks/useAuth";

import { Settings, Logout } from "@assets/icons";

/** Languages */
import useTranslation from "@languages/useTranslation";
import { CustomerMessages } from "src/languages/interfaces/customerMessages";
import { SettingMessages } from "src/languages/interfaces/settingMessages";

import SidebarDrawerMenu from "@atoms/SidebarDrawerMenu";

/** Molecules */
import { MenuItem } from "@molecules/SidebarMenus";

import useTheme from "@styles/useTheme";

const SidebarDrawerSecondaryMenus: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const { signOut } = useAuth();

  const SidebarMenuItems: MenuItem[] = [
    {
      id: "10",
      title: SettingMessages.settingTitlePage,
      icon: Settings,
      link: "/settings"
    },
    {
      id: "11",
      title: CustomerMessages.applicationLogout,
      icon: Logout,
      link: "/",
      onClick: signOut
    }
  ];

  return (
    <>
      {SidebarMenuItems.map(({ id, title, icon, link, onClick }) => (
        <SidebarDrawerMenu
          key={`${id}_${title}`}
          id={id}
          title={t(title)}
          icon={icon}
          link={link}
          onClick={onClick}
          secondaryColor={theme.colors.secondary}
          identifierColor={theme.colors.tertiary}
          type="secondary"
        />
      ))}
    </>
  );
};

export default React.memo(SidebarDrawerSecondaryMenus);
